module.exports = "<ul>\n<li>Bachelor degree, Computer Science,\n<a href=\"https://en.smtu.ru\">Saint-Petersburg State Marine University</a></li>\n<li>Masters degree, Computer Science,\n<a href=\"https://en.smtu.ru\">Saint-Petersburg State Marine University</a></li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/articles/education.md
// module id = OFOS
// module chunks = 1